/**
 * Fixture runs for Phase 1 of the Missions UI.
 *
 * GW-8054: Per-mission runs table at /personal/missions/:missionId (D8) reads
 * `Run[]` records (the canonical gw-missions-api poll-contract shape) keyed
 * by the parent mission's record id. In fixture mode, `fixtureRuns` supplies
 * that data filtered by `run.missionId === <mission record id>`.
 *
 * One run per `fixtureMissions.runCount`: `mission-fix-001` (in_progress, 1
 * live run), `mission-fix-002` (complete, 2 runs — an earlier failed attempt
 * plus the completed run referenced by `latestRunId`), `mission-fix-003`
 * (aborted, 1 cancelled run).
 */

import type { Run } from '@gw/ui/types';

export const fixtureRuns: Run[] = [
  {
    missionId: 'mission-fix-001',
    runId: 'run-fix-001-a',
    missionType: 'MISSION-02',
    status: 'running',
    holdId: 'hold-fix-001-a',
    tokenBudget: 400,
    productCompleteness: { 'PROD-002': 0.4 },
    totalDurationSeconds: null,
    costSummary: null,
    // GW-10336: an in-progress run's live, non-authoritative spend
    // (missions-runs-progress writes this on every mission.run.* event) —
    // costSummary stays null until settlement.
    runningCostSummary: { spent: 62, remaining: 338, percent: 15.5 },
    createdAt: '2026-04-28T14:10:00Z',
    updatedAt: '2026-04-29T09:22:00Z',
  },
  {
    missionId: 'mission-fix-002',
    runId: 'run-fix-002-a',
    missionType: 'MISSION-11',
    status: 'failed',
    holdId: 'hold-fix-002-a',
    productCompleteness: {},
    totalDurationSeconds: 620,
    costSummary: null,
    createdAt: '2026-04-19T10:00:00Z',
    updatedAt: '2026-04-19T10:10:20Z',
  },
  {
    missionId: 'mission-fix-002',
    runId: 'run-fix-002-b',
    missionType: 'MISSION-11',
    status: 'completed',
    holdId: 'hold-fix-002-b',
    productCompleteness: { 'PROD-006': 1, 'PROD-015': 1 },
    totalDurationSeconds: 6420,
    costSummary: {
      totalSmartTokensSpent: 247,
      datasetQueryCostTokens: 180,
      inferenceCostTokens: 67,
      drawnAmount: 67,
      releasedAmount: 113,
    },
    createdAt: '2026-04-20T08:00:00Z',
    updatedAt: '2026-04-22T17:45:00Z',
  },
  {
    missionId: 'mission-fix-003',
    runId: 'run-fix-003-a',
    missionType: 'MISSION-02',
    status: 'cancelled',
    holdId: 'hold-fix-003-a',
    productCompleteness: {},
    totalDurationSeconds: 2100,
    costSummary: null,
    createdAt: '2026-04-18T12:00:00Z',
    updatedAt: '2026-04-18T12:35:00Z',
  },
];
